import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanMatch,
    NavigationExtras,
    ParamMap,
    Route,
    Router,
    RouterStateSnapshot,
    UrlSegment,
} from '@angular/router';
import { AuthService } from '@thinglogix/ngx-foundry-core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanMatch {
    constructor(private authService: AuthService, private router: Router) {}

    canActivate(
        _route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean | Observable<boolean> {
        return this.checkLoggedIn(state.url);
    }

    canMatch(
        _route: Route,
        segments: UrlSegment[]
    ): boolean | Observable<boolean> {
        const fullPath = segments.reduce((path, currentSegment) => {
            return `${path}/${currentSegment.path}`;
        }, '');

        return this.checkLoggedIn(
            fullPath,
            this.router.getCurrentNavigation()?.extractedUrl.queryParamMap
        );
    }

    private checkLoggedIn(
        returnUrl: string,
        queryParams?: ParamMap
    ): boolean | Observable<boolean> {
        const { user } = this.authService;
        if (user && !user.api_user_only) {
            if (
                user.cognito &&
                user.cognito.api_gateway_endpoint &&
                user.cognito.cognito_identity_pool_id &&
                user.cognito.cognito_developer_provider_name
            ) {
                return this.authService.refreshAWSConfig().pipe(
                    map((valid) => {
                        if (!valid) {
                            this.signOut(returnUrl, queryParams);
                        }
                        return valid;
                    }),
                    catchError((err) => {
                        console.error(err);
                        this.signOut(returnUrl, queryParams);

                        return of(false);
                    })
                );
            }
            this.signOut(returnUrl, queryParams);

            return of(false);
        }
        this.signOut(returnUrl, queryParams);
        return of(false);
    }

    private signOut(returnUrl: string, queryParams?: ParamMap): void {
        this.authService.signOutUser();
        console.log('signed out');
        this.authService.clearLocalStorage();
        console.log('cleared');

        const params: NavigationExtras = {
            queryParams: {
                returnUrl: returnUrl !== '' ? returnUrl : undefined,
            },
        };

        if (queryParams) {
            queryParams.keys.forEach((key) => {
                if (params.queryParams) {
                    params.queryParams[key] = queryParams.get(key);
                }
            });
        }

        console.log('routing');
        void this.router.navigate(['/auth/login'], params);
    }
}
